var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBagDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8987_234",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 20,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.75C20.5188 3.75 21.75 4.98122 21.75 6.5V17.5C21.75 19.0188 20.5188 20.25 19 20.25H5C3.48122 20.25 2.25 19.0188 2.25 17.5V6.5C2.25 4.98122 3.48122 3.75 5 3.75H19ZM5 5.25C4.30964 5.25 3.75 5.80964 3.75 6.5V17.5C3.75 18.1904 4.30964 18.75 5 18.75H19C19.6904 18.75 20.25 18.1904 20.25 17.5V6.5C20.25 5.80964 19.6904 5.25 19 5.25H5ZM15.75 7.5C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 9.44347 16.0256 10.5877 15.1816 11.4316C14.3377 12.2756 13.1935 12.75 12 12.75C10.8065 12.75 9.66227 12.2756 8.81836 11.4316C7.97445 10.5877 7.5 9.44347 7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5C8.66421 7.5 9 7.83579 9 8.25C9 9.04565 9.3163 9.80848 9.87891 10.3711C10.4415 10.9337 11.2044 11.25 12 11.25C12.7956 11.25 13.5585 10.9337 14.1211 10.3711C14.6837 9.80848 15 9.04565 15 8.25C15 7.83579 15.3358 7.5 15.75 7.5Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8987_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagDelivery);
export default __webpack_public_path__ + "static/media/shopping-bag-delivery.77c76ee8dff4f7175412b6e2a38a44ea.svg";
export { ForwardRef as ReactComponent };